import { dateTimeFormatter, valueFormatter } from '../../config/timeFormatters';
import { html, toHtmlString } from '../../utils/html';
import type { TooltipCard } from './TooltipCard.types';
import styles from './timeSeriesChartTooltip.module.css';

function formatValue({ value, unit }: TooltipCard) {
  const formatted = valueFormatter.format(value);

  return unit ? `${formatted} ${unit}` : formatted;
}

function renderCard(card: TooltipCard) {
  const borderStyle = card.color ? `border-color:${card.color}` : '';

  return html`
    <div class="${styles.card}" style="${borderStyle}">
      <div class="${styles.value}">${formatValue(card)}</div>
      <div class="${styles.meta}">${dateTimeFormatter.format(card.timestamp)}</div>
      <div class="${styles.meta}">${card.label}</div>
    </div>
  `;
}

/** Plain HTML for the ECharts tooltip formatter; every card value goes through the escaping `html` tag. */
export function renderTooltipCards(cards: TooltipCard[]): string {
  if (cards.length === 0) {
    return '';
  }

  return toHtmlString(html`<div class="${styles.container}">${cards.map(renderCard)}</div>`);
}
